import { push } from "connected-react-router";
import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
  APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE,
  ROUTE_PATH,
} from "../../app/constants";
import { GetProviceCodeFromName, ValidateString } from "../../app/utils";
import { CanadaProvinceList } from "../../app/constants";
import { Header, Button, ErrorMark } from "../../components/RegularComponents";
import { ErrorWithString } from "../../components/RegularComponents";
import TopNavigationBar from "../TopNavigationBar";
import {
  ERROR_STRING,
  VALIDATION_TYPE,
  VALIDATION_ERROR,
  homeAddressErrorString,
  cityErrorString,
  postalCodeErrorString,
  phoneNumberErrorString,
  emailErrorString,
} from "../../app/errors";
import { setCurrentAgentMortgageProperty } from "../../redux/slice/additionalApplicationsSlice";
import { mraPrincipalBrokerSelector } from "../../redux/selector/mraPrincipalBrokerSelector";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { setAgencyBusinessContact, setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";

const MORTGAGE_APPLICATION_PROPERTY = "personData";

export const ProvideBrokerContactInformation = (props) => {
  // Will probably need a special state selector here
  const { principalBrokerApplication } = useSelector(
    mraPrincipalBrokerSelector
  );

  const businessContact = useSelector(
    state => state.primaryAgencyApplication.application?.businessLicenceData?.mainBusinessContact ?? {}
  )

  const mortgageBrokerContactInfo = useMemo(() => {
      return (
        principalBrokerApplication?.businessLicenceData
        ?.personData ?? {}
      )
  }, [principalBrokerApplication])

  const addressData = useMemo(() => {
      return (
        mortgageBrokerContactInfo?.addressData ?? {}
      );
  }, [mortgageBrokerContactInfo])

  const { isModal = false, onEditSave = () => {} } = props;

  const dispatch = useDispatch();
  // const applicationType = APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE;
  const applicationMode = APPLICATION_MODE_NEW;
  const [applicationSaveError, setApplicationSaveError] = useState(false);
  const [homeAddress, setHomeAddress] = useState(
    addressData.address1
  );
  const [homeAddressError, setHomeAddressError] = useState(
    VALIDATION_ERROR.NO_ERROR
  );
  const [phone, setPhone] = useState(mortgageBrokerContactInfo.phoneNumber);
  const [phoneError, setPhoneError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [altPhoneError, setAltPhoneError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [altPhone, setAltPhone] = useState(
    mortgageBrokerContactInfo.alternatePhoneNumber
  );
  const [email, setEmail] = useState(mortgageBrokerContactInfo.email);
  const [province, setProvince] = useState(addressData.stateName);
  const [emailError, setEmailError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [city, setCity] = useState(addressData.cityName);
  const [cityError, setCityError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [showValidationError, setShowValidationError] = useState(false);
  const [provinceError, setProvinceError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [postalCode, setPostalCode] = useState(
    addressData.postalCode
  );
  const [postalCodeError, setPostalCodeError] = useState(
    VALIDATION_ERROR.NO_ERROR
  );

  useEffect(() => {
    homeAddressError === VALIDATION_ERROR.NO_ERROR &&
    phoneError === VALIDATION_ERROR.NO_ERROR &&
    emailError === VALIDATION_ERROR.NO_ERROR &&
    cityError === VALIDATION_ERROR.NO_ERROR &&
    postalCodeError === VALIDATION_ERROR.NO_ERROR
      ? setShowValidationError(false)
      : setShowValidationError(true);
  }, [
    homeAddressError,
    phoneError,
    emailError,
    cityError,
    postalCodeError,
  ]);

  const provinceOptionElements = useMemo(() => {
    return Object.keys(CanadaProvinceList).map((key) => {
      const element = CanadaProvinceList[key];
      return (
        <option key={key} value={element}>
          {element}
        </option>
      );
    });
  }, []);

  const validateData = () => {
    const ret1 = ValidateString(homeAddress, VALIDATION_TYPE.STRING_NON_EMPTY);
    setHomeAddressError(ret1);

    const ret2 = ValidateString(phone, VALIDATION_TYPE.PHONE_NUMBER);
    setPhoneError(ret2);

    let ret3 = ValidateString(altPhone, VALIDATION_TYPE.PHONE_NUMBER);
    if(ret3 === VALIDATION_ERROR.EMPTY) {
      ret3 = VALIDATION_ERROR.NO_ERROR
    }
    setAltPhoneError(ret3);

    const ret4 = ValidateString(email, VALIDATION_TYPE.EMAIL);
    setEmailError(ret4);

    const ret5 = ValidateString(city, VALIDATION_TYPE.STRING_NON_EMPTY);
    setCityError(ret5);

    const ret6 = ValidateString(GetProviceCodeFromName(province), VALIDATION_TYPE.CANADA_PROVINCE_CODE);
    setProvinceError(ret6);

    const ret7 = ValidateString(postalCode, VALIDATION_TYPE.CANADA_POSTAL_CODE);
    setPostalCodeError(ret7);

    return (
      ret1 === VALIDATION_ERROR.NO_ERROR &&
      ret2 === VALIDATION_ERROR.NO_ERROR &&
      ret3 === VALIDATION_ERROR.NO_ERROR &&
      ret4 === VALIDATION_ERROR.NO_ERROR &&
      ret5 === VALIDATION_ERROR.NO_ERROR &&
      ret6 === VALIDATION_ERROR.NO_ERROR &&
      ret7 === VALIDATION_ERROR.NO_ERROR
    );
  };

  const handleSave = () => {
    //reset errors
    setShowValidationError(false);
    setHomeAddressError(VALIDATION_ERROR.NO_ERROR);
    setPhoneError(VALIDATION_ERROR.NO_ERROR);
    setEmailError(VALIDATION_ERROR.NO_ERROR);
    setCityError(VALIDATION_ERROR.NO_ERROR);
    setProvinceError(VALIDATION_ERROR.NO_ERROR);
    setPostalCodeError(VALIDATION_ERROR.NO_ERROR);

    if (!validateData()) {
      setShowValidationError(true);
      return false;
    }

    const update = {
      key: MORTGAGE_APPLICATION_PROPERTY,
      value: {
        ...mortgageBrokerContactInfo,
        addressData: {
          address1 : homeAddress,
          stateName: province,
          cityName: city,
          postalCode: postalCode,
        },
        phoneNumber: phone,
        alternatePhoneNumber: altPhone,
        email: email,
      },
    };

    dispatch(setCurrentAgentMortgageProperty(update));
    dispatch(setCurrentAgentMortgageProperty({
      key : "mainBusinessContact",
      value : {
        ...businessContact,
        phoneNumber: phone,
        emailAddress: email, 
      }
    }))

    dispatch(setMortgageProperty(update))
    dispatch(setAgencyBusinessContact({
      mainBusinessContact : {
        ...businessContact,
        phoneNumber: phone,
        emailAddress: email,
      }
    }))


    return true;
  }

  const handleSaveAndNext = () => {
    if (handleSave()) { 
      //Main app + parent app has to be updated
      const p1 = dispatch(saveBusinessLicenceApplicationData(
        APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE, applicationMode))
      const p2 = dispatch(saveBusinessLicenceApplicationData(
        APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, applicationMode))

      Promise.all([p1,p2])
        .then(values => {
          // On to the next item
          dispatch(
            push(
              `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_CONFIRM_COMPLETION_REGULATORY_INFO}`
            )
          );
        })
        .catch((err) => {
          setApplicationSaveError(true);
        });
    };
  }

  const handleSaveandClose = () => {
    if(handleSave()) {
      onEditSave();
    }
  };

  const handleHomeAddressChange = (e) => {
    setHomeAddress(e.target.value);
    setHomeAddressError(VALIDATION_ERROR.NO_ERROR);
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
    setPhoneError(VALIDATION_ERROR.NO_ERROR);
  };

  const handleAltPhoneChange = (e) => {
    setAltPhone(e.target.value);
    setAltPhoneError(VALIDATION_ERROR.NO_ERROR);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError(VALIDATION_ERROR.NO_ERROR);
  };

  const handleCityChange = (e) => {
    setCity(e.target.value);
    setCityError(VALIDATION_ERROR.NO_ERROR);
  };

  const handlePostalCodeChange = (e) => {
    setPostalCode(e.target.value);
    setPostalCodeError(VALIDATION_ERROR.NO_ERROR);
  };

  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar {...props} />
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Header
                  style={{ paddingBottom: "30px" }}
                  id="broker-contact-informtion-header"
                  header="Provide your contact information as a principal broker"
                />
              </div>
            </div>
          </>
        )}

        {/* Home Address */}
        <div className="row">
          <div className="col-lg-8">
            <div className={
              "ns-fieldset" +
              ((homeAddressError !== VALIDATION_ERROR.NO_ERROR)
                ? " has-error ns-fieldset-message-error"
                : "")
            }>
            <fieldset className="ns-fieldset">
              <label
                id={"broker-contact-informtion-home-address-label"}
                className="ns-label"
                htmlFor={"broker-contact-informtion-home-address-text"}
              >
                Home Address
              </label>
              {homeAddressError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"broker-contact-informtion-home-address-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString(homeAddressErrorString(homeAddressError))}
                </span>
              )}
              <input
                type="text"
                className={
                  "fw-25" +
                  (homeAddressError === VALIDATION_ERROR.NO_ERROR
                    ? " ns-input"
                    : " ns-input--error")
                }
                id={"broker-contact-informtion-home-address-text"}
                name={"broker-contact-informtion-home-address-text"}
                value={homeAddress}
                onChange={handleHomeAddressChange}
              />
            </fieldset>
            </div>
          </div>
        </div>

        {/* City */}
        <div className="row">
          <div className="col-lg-8">
            <div className={
              "ns-fieldset" +
              ((cityError !== VALIDATION_ERROR.NO_ERROR)
                ? " has-error ns-fieldset-message-error"
                : "")
            }>
            <fieldset className="ns-fieldset">
              <label
                id={"mortgage-broker-licence-number-label"}
                className="ns-label"
                autoComplete="postal-code"
                htmlFor={"mortgage-broker-licence-number-text"}
              >
                City
              </label>
              {cityError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"mortgage-broker-licence-number-text-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString(cityErrorString(cityError))}
                </span>
              )}
              <input
                type="text"
                className={
                  "fw-25" +
                  (cityError === VALIDATION_ERROR.NO_ERROR
                    ? " ns-input"
                    : " ns-input--error")
                }
                id={"mortgage-broker-licence-number-text"}
                name={"mortgage-broker-licence-number-text"}
                value={city}
                onChange={handleCityChange}
              />
            </fieldset>
            </div>
          </div>
        </div>

        {/* Province Select section */}
        <div className="row">
          <div className="col-lg-8">
            <div
              className={
                "ns-fieldset" +
                ((provinceError !== VALIDATION_ERROR.NO_ERROR) ? " has-error ns-fieldset-message-error" : "")
              }
            >
              <label
                id={"mra-province-select-label"}
                className="ns-label"
                htmlFor={"mra-province-select-input"}
              >
                Province
              </label>
              {(provinceError !== VALIDATION_ERROR.NO_ERROR) && (
                <span
                  id={"mra-province-select-input-error"}
                  className="ns-error-message fieldset-validation-error"
                >
                  {ErrorWithString(ERROR_STRING.CONTACT_DETAILS_PROVINCE_EMPTY)}
                </span>
              )}
              <div className="select fw-25 inlineDisplay">
                <select
                  className={(provinceError !== VALIDATION_ERROR.NO_ERROR) ? "select--error" : ""}
                  style={{ width: "25em" }}
                  id={"mra-province-select-input"}
                  name={"mra-province-select-input"}
                  value={province ?? ""}
                  onChange={(e) => {
                    setProvince(e.target.value);
                    setProvinceError(VALIDATION_ERROR.NO_ERROR)
                  }}
                >
                  {provinceOptionElements}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Postal Code */}
        <div className="row">
          <div className="col-lg-8">
            <div className={
              "ns-fieldset" +
              ((postalCodeError !== VALIDATION_ERROR.NO_ERROR)
                ? " has-error ns-fieldset-message-error"
                : "")
            }>
            <fieldset className="ns-fieldset">
              <label
                id={"mortgage-broker-licence-number-label"}
                className="ns-label"
                autoComplete="postal-code"
                htmlFor={"mortgage-broker-licence-number-text"}
              >
                Postal Code
              </label>
              {postalCodeError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"mortgage-broker-licence-number-text-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString(postalCodeErrorString(postalCodeError))}
                </span>
              )}
              <input
                type="text"
                className={
                  "fw-25" +
                  (postalCodeError === VALIDATION_ERROR.NO_ERROR
                    ? " ns-input"
                    : " ns-input--error")
                }
                id={"mortgage-broker-licence-number-text"}
                name={"mortgage-broker-licence-number-text"}
                value={postalCode}
                onChange={handlePostalCodeChange}
              />
            </fieldset>
            </div>
          </div>
        </div>

        {/* Phone */}
        <div className="row">
          <div className="col-lg-8">
            <div className={
              "ns-fieldset" +
              ((phoneError !== VALIDATION_ERROR.NO_ERROR)
                ? " has-error ns-fieldset-message-error"
                : "")
            }>
            <fieldset className="ns-fieldset">
              <label
                id={"broker-contact-informtion-phone-label"}
                className="ns-label"
                htmlFor={"broker-contact-informtion-phone-text"}
              >
                Phone number
              </label>
              {phoneError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"broker-contact-informtion-phone-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString(phoneNumberErrorString(phoneError))}
                </span>
              )}
              <input
                type="text"
                className={
                  "fw-25" +
                  (phoneError === VALIDATION_ERROR.NO_ERROR
                    ? " ns-input"
                    : " ns-input--error")
                }
                id={"broker-contact-informtion-phone-text"}
                name={"broker-contact-informtion-phone-text"}
                value={phone}
                onChange={handlePhoneChange}
              />
            </fieldset>
            </div>
          </div>
        </div>

        {/* Alt Phone */}
        <div className="row">
          <div className="col-lg-8">
            <div className={
              "ns-fieldset" +
              ((altPhoneError !== VALIDATION_ERROR.NO_ERROR)
                ? " has-error ns-fieldset-message-error"
                : "")
            }>
            <fieldset className="ns-fieldset">
              <label
                id={"broker-contact-informtion-alt-phone-label"}
                className="ns-label"
                htmlFor={"broker-contact-informtion-alt-phone-text"}
              >
                Alternate Phone number (Optional)
              </label>
              {altPhoneError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"broker-contact-informtion-phone-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString(phoneNumberErrorString(altPhoneError))}
                </span>
              )}
              <input
                type="text"
                className={
                  "fw-25" +
                  (altPhoneError === VALIDATION_ERROR.NO_ERROR
                    ? " ns-input"
                    : " ns-input--error")
                }
                id={"broker-contact-informtion-alt-phone-text"}
                name={"broker-contact-informtion-alt-phone-text"}
                value={altPhone}
                onChange={handleAltPhoneChange}
              />
            </fieldset>
          </div>
          </div>
        </div>

        {/* Email */}
        <div className="row">
          <div className="col-lg-8">
            <div className={
              "ns-fieldset" +
              ((emailError !== VALIDATION_ERROR.NO_ERROR)
                ? " has-error ns-fieldset-message-error"
                : "")
            }>
            <fieldset className="ns-fieldset">
              <label
                id={"broker-contact-informtion-email-label"}
                className="ns-label"
                htmlFor={"broker-contact-informtion-email-text"}
              >
                Email
              </label>
              {emailError !== VALIDATION_ERROR.NO_ERROR && (
                <span
                  id={"broker-contact-informtion-email-error"}
                  className="ns-error-message field-validation-error"
                >
                  {ErrorWithString(emailErrorString(emailError))}
                </span>
              )}
              <input
                type="text"
                className={
                  "fw-25" +
                  (emailError === VALIDATION_ERROR.NO_ERROR
                    ? " ns-input"
                    : " ns-input--error")
                }
                id={"broker-contact-informtion-alt-phone-text"}
                name={"broker-contact-informtion-alt-phone-text"}
                value={email}
                onChange={handleEmailChange}
              />
            </fieldset>
            </div>
          </div>
        </div>

        <div className="row">
          <div
            className={
              "col-lg-4" +
              (showValidationError || applicationSaveError ? " has-error" : "")
            }
          >
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Save and next" : "Save and close"}
              onClick={!isModal ? handleSaveAndNext : handleSaveandClose}
            />
            {(showValidationError || applicationSaveError) && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CHECK_FIELDS}
              </div>
            )}
            {applicationSaveError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
